<template>
	<div style="background-color: white">
		<!-- <vs-button
			v-if="closeFormShow"
			class="float-right m-5"
			radius
			color="primary"
			type="filled"
			icon-pack="feather"
			icon="icon-x"
			@click="returnPrevRoute"
		></vs-button> -->
		<form-wizard
			style="width: 80vw"
			color="rgba(var(--vs-primary), 1)"
			title="Création d'un client"
			subtitle="Ajoutez un client et associez lui des contacts"
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Terminer"
		>
			<tab-content
				title="Création du client"
				class="mb-2"
				:before-change="saveSociety"
			>
				<!-- tab 1 content -->
				<div class="vx-row">
					<!-- STATUS -->
					<!-- <div class="vx-col w-1/4">
            <vx-input-group class="w-full center">
              <vs-switch v-model="society.status">
                <span slot="on">Statut Actif</span>
                <span slot="off">Statut Inactif</span>
              </vs-switch>
            </vx-input-group>
          </div> -->
					<div class="vx-col w-full">
						<span class="float-right">* champ obligatoire</span>
					</div>
				</div>
				<!-- /STATUS -->

				<div class="vx-row mt-4">
					<!-- Nom de la societé -->
					<div class="vx-col sm:w-1/4 w-full flex" style="white-space: nowrap">
						<vx-input-group class="inlineB bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon> *</span
									>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('name')"
									placeholder="Nom de la societé"
									v-model="society.name"
									@change="validateOne(society.name, 'name')"
								/>
								<vx-tooltip
									v-if="validators['name'] && validators['name'].errText !== ''"
									:text="errText('name')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /Nom de la societé -->
					<!-- Commercial -->
					<div class="vx-col sm:w-1/4 flex" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>Commercial(e) *</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									:style="styleValidator('commercial_id')"
									v-model="society.commercial_id"
									class="select-medium mr-2"
									@change="validateOne(society.commercial_id, 'commercial_id')"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.firstname + ' ' + item.lastname"
										v-for="(item, index) in commercials"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['commercial_id'] &&
										validators['commercial_id'].errText !== ''
									"
									:text="errText('commercial_id')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /Commercial -->
					<!-- Client origine commerciale -->
					<div
						class="vx-col sm:w-1/4 w-full flex justify-center items-center space-x-2"
						style="white-space: nowrap"
					>
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>Origine *</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									autocomplete
									:style="styleValidator('origin')"
									v-model="society.origin"
									class="w-full select-medium mr-2"
									@change="validateOne(society.origin, 'origin')"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in originOptions"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['origin'] && validators['origin'].errText !== ''
									"
									:text="errText('origin')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
						<vx-tooltip text="Comment avons-nous atteint ce client ?">
							<vs-icon
								icon="info_outline"
								size="small"
								style="cursor: pointer"
							></vs-icon>
						</vx-tooltip>
					</div>
					<!-- /Client origine commerciale -->
					<!-- ACTIVITY_DOMAIN -->
					<div class="vx-col sm:w-1/4" style="white-space: nowrap">
						<vx-input-group class="inlineB bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon>*</span
									>
								</div>
							</template>
							<vue-tags
								class="w-full"
								placeholder="Domaine d'activité"
								:active="society.activity_domain"
								:all="listDomaine"
								:tag-creation-enabled="true"
								tag-list-label=""
								@on-tag-added="onTagAdded($event)"
								@on-tag-removed="onTagRemoved($event)"
								@on-tag-created="onTagAdded($event)"
								@on-tag-list-opened="
									tagStyle = 'z-index: 1 !important; overflow: visible;'
								"
								@on-tag-list-closed="
									tagStyle = 'z-index: 1 !important; overflow: auto;';
									validateOne(society.activity_domain, 'activity_domain');
								"
								:style="tagStyle"
							>
							</vue-tags>
							<template slot="append">
								<vx-tooltip
									v-if="
										validators['activity_domain'] &&
										validators['activity_domain'].errText !== ''
									"
									:text="errText('activity_domain')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</template>
						</vx-input-group>
					</div>
					<!-- /ACTIVITY_DOMAIN -->
				</div>
				<div class="vx-row mt-4">
					<!-- WEBSITE -->
					<div class="vx-col sm:w-1/4 w-full flex" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="http" size="medium"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('website')"
									v-model="society.website"
									placeholder="Site web"
									@change="validateOne(society.website, 'websiteOptional')"
								/>
								<vx-tooltip
									v-if="
										validators['websiteOptional'] &&
										validators['websiteOptional'].errText !== ''
									"
									:text="errText('websiteOptional')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /WEBSITE -->
					<!-- ISECOMMERCE -->
					<div class="vx-col sm:w-1/4 w-full">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>Type*</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									autocomplete
									:style="styleValidator('is_ecommerce')"
									v-model="society.is_ecommerce"
									class="w-full select-medium"
									@change="validateOne(society.is_ecommerce, 'is_ecommerce')"
								>
									<vs-select-item
										class="w-full"
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in ecommerceOptions"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['is_ecommerce'] &&
										validators['is_ecommerce'].errText !== ''
									"
									:text="errText('is_ecommerce')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /ISECOMMERCE -->
					<!-- LANGUE -->
					<div class="vx-col sm:w-1/4 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="language" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.language_id"
								placeholder="Langue de la facture"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in languages"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<!-- LANGUE -->
					<!-- Currencies -->
					<div class="vx-col sm:w-1/4 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="money" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.currency_id"
								placeholder="Devise de la facture"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in currencies"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<!-- Currencies -->
				</div>
				<!-- CONTACT INFORMATION -->
				<vs-divider position="center" class="m-10"> CONTACT </vs-divider>
				<div class="vx-row mt-4">
					<!-- ADRESSE -->
					<div class="vx-col sm:w-1/2 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_on" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input placeholder="Adresse" v-model="society.adress" />
						</vx-input-group>
					</div>
					<!-- /ADRESSE -->
					<!-- COMPLEMENT D'ADRESSE -->
					<div class="vx-col sm:w-1/2 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_on" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								placeholder="Complément d'adresse"
								v-model="society.adress_complement"
							/>
						</vx-input-group>
					</div>
					<!-- /COMPLEMENT D'ADRESSE -->
				</div>
				<div class="vx-row mt-4">
					<!-- PAYS -->
					<div class="vx-col sm:w-1/4 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_on" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.country"
								class="w-full select-medium"
								@change="validateOne(society.country, 'country')"
							>
								<vs-select-item
									:key="index"
									:value="item.alpha2"
									:text="item.fr_fr_name"
									v-for="(item, index) in countries"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<!-- /PAYS -->
					<!-- CODE POSTAL -->
					<div class="vx-col sm:w-1/4 w-full" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"><p>CP</p></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('codePostal')"
									placeholder="Code postal"
									v-model="society.postal_code"
									@change="validateOne(society.postal_code, 'codePostal')"
								/>
								<vx-tooltip
									v-if="
										validators['codePostal'] &&
										validators['codePostal'].errText !== ''
									"
									:text="errText('codePostal')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /CODE POSTAL -->
					<!-- VILLE -->
					<div class="vx-col sm:w-1/4 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_city" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input placeholder="Ville" v-model="society.city" />
						</vx-input-group>
					</div>
					<!-- /VILLE -->
					<div class="vx-col sm:w-1/4 w-full" style="white-space: nowrap">
						<!-- PHONE -->
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="local_phone" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('phone')"
									v-model="society.phone"
									placeholder="Téléphone"
									@change="validateOne(society.phone, 'phone')"
								/>
								<vx-tooltip
									v-if="
										validators['phone'] && validators['phone'].errText !== ''
									"
									:text="errText('phone')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
						<!-- /PHONE -->
					</div>
				</div>
				<vs-divider position="center" class="m-10"> Adminstration </vs-divider>
				<div class="vx-row mt-4">
					<!-- TVA -->
					<div class="vx-col sm:w-1/3 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="gavel" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								:style="styleValidator('country')"
								@change="validateOne(society.tva, 'tva')"
								v-model="society.tva"
								placeholder="Numéro de TVA"
							/>
						</vx-input-group>
						<vx-tooltip
							v-if="
								validators['country'] && validators['country'].errText !== ''
							"
							:text="errText('country')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<div class="vx-col sm:w-1/3 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="gavel" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.tva_id"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in tva_ids"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<!-- /TVA -->
					<!-- SIRET -->
					<div class="vx-col sm:w-1/3 w-full flex" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex">SIRET</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('siret')"
									v-model="society.siret"
									@change="validateOne(society.siret, 'siret')"
									placeholder="000 000 000 00000"
								/>
								<vx-tooltip
									v-if="
										validators['siret'] && validators['siret'].errText !== ''
									"
									:text="errText('siret')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: #ff0000"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /SIRET -->
				</div>
				<vs-divider position="center" class="m-10"> Analytics </vs-divider>
				<div class="vx-row mt-4">
					<!-- SEARCH CONSOLE -->
					<div
						class="vx-col sm:w-1/4 w-full flex justify-center items-center space-x-2"
					>
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="show_chart" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								placeholder="Url (search console)"
								v-model="society.gsc_url"
							/>
						</vx-input-group>
						<vx-tooltip
							text="Veuillez saisir l'adresse Google Search Console associée au site du client."
						>
							<vs-icon
								icon="info_outline"
								size="small"
								style="cursor: pointer"
							></vs-icon>
						</vx-tooltip>
					</div>
					<!-- /SEARCH CONSOLE -->
					<!-- ANALYTICS -->
					<div
						class="vx-col sm:w-1/4 w-full flex justify-center items-center space-x-2"
					>
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="bar_chart" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								placeholder="View Id (analytics)"
								v-model.number="society.analytics_id"
							/>
						</vx-input-group>
						<vx-tooltip
							text="Veuillez saisir l'identifiant analytics du client."
						>
							<vs-icon
								icon="info_outline"
								size="small"
								style="cursor: pointer"
							></vs-icon>
						</vx-tooltip>
					</div>
					<!-- Google Ads MCC ID -->
					<div
						class="vx-col sm:w-1/4 w-full flex justify-center items-center space-x-2"
					>
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="show_chart" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								placeholder="MCC Id (Google ads)"
								v-model="society.google_ads_mcc"
							/>
						</vx-input-group>
						<vx-tooltip
							text="Veuillez saisir MCC Id du Google Ads associée au site du client."
						>
							<vs-icon
								icon="info_outline"
								size="small"
								style="cursor: pointer"
							></vs-icon>
						</vx-tooltip>
					</div>
					<!-- /Google Ads MCC ID -->
					<div class="vx-col sm:w-1/4 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="gavel" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.term_id"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in termsOptions"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<div class="vx-col sm:w-1/4 mt-2">
						<vs-button @click="copyDashboardUrlToClipboard"
							>Copier l'adresse à récupérer</vs-button
						>
					</div>
					<!-- /ANALYTICS -->
				</div>
				<div class="vx-row">
					<vs-alert :active="alertBool">
						Adresse du dashboard copiée avec succès dans le presse-papier.
					</vs-alert>
				</div>
				<div class="vx-row">
					<!-- IMAGE -->
					<div class="vx-col mt-6">
						<vs-card style="min-width: 300px; max-width: 350px">
							<div slot="header">
								<p>Sélectionnez une image</p>
								<input
									type="file"
									name="file"
									accept="image/*"
									@change="addImagePreview($event)"
								/>
							</div>
							<div>
								<div class="vx-col w-full" v-if="image">
									<vue-cropper
										ref="cropper"
										:src="image"
										preview=".preview"
										:cropBoxResizable="false"
										:cropBoxMovable="false"
										:minCropBoxWidth="264"
										:minCropBoxHeight="150"
										:minCanvasWidth="264"
										:minCanvasHeight="150"
										dragMode="move"
									/>
								</div>
							</div>
							<div slot="footer" v-if="image">
								<vs-row vs-justify="flex-end">
									<vs-button color="success" @click="imageZoom">+</vs-button>

									<vs-button color="danger" @click="imageDezoom">-</vs-button>
								</vs-row>
							</div>
						</vs-card>
					</div>
					<!-- /IMAGE -->
				</div>
			</tab-content>

			<!-- tab 2 content -->
			<tab-content title="Ajout des contacts" class="mb-5">
				<div class="vx-col" v-if="societyContact && !clickAddContact">
					<div class="vx-row center_div">
						<vs-table :data="societyContact">
							<template slot="thead">
								<vs-th>Civilité</vs-th>
								<!-- Madame ou Monsieur -->
								<vs-th>Prénom</vs-th>
								<!-- Prénom -->
								<vs-th>Nom</vs-th>
								<!-- Nom -->
								<vs-th>Type de contact</vs-th>
								<!-- Commercial ou Facturation -->
								<vs-th>Fonction</vs-th>
								<!-- PDG, Directeur marketing... -->
								<vs-th>Email</vs-th>
								<!-- Email -->
								<vs-th>Téléphone</vs-th>
								<!-- Téléphone -->
								<vs-th>Accès Dashboard</vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>{{ getUserCivility(data[indextr].civility) }}</vs-td>
									<!-- Madame ou Monsieur -->
									<vs-td>{{ data[indextr].firstname }}</vs-td>
									<!-- Prénom -->
									<vs-td>{{ data[indextr].lastname }}</vs-td>
									<!-- Nom -->
									<vs-td>{{ getUserTitle(data[indextr].type) }}</vs-td>
									<!-- Commercial ou Facturation -->
									<vs-td>{{ getFonction(data[indextr].fonction) }}</vs-td>
									<!-- PDG, Directeur marketing -->
									<vs-td>{{ data[indextr].email }}</vs-td>
									<!-- Email -->
									<vs-td>{{ data[indextr].phone }}</vs-td>
									<!-- Téléphone -->
									<vs-td style="text-align: center">{{
										getUserDashboardAccess(data[indextr].hasAccess)
									}}</vs-td>
									<!-- hasAccess to Dashboard -->
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
				<div class="vx-col mt-4">
					<div class="vx-row center_div">
						<vs-button
							type="filled"
							@click="showContactForm"
							v-if="!clickAddContact"
							>Ajouter un contact</vs-button
						>
					</div>
					<div>
						<ContactForSociety
							:contactAdded="contactAdded"
							:society="society"
							:show="clickAddContact"
							@closeForm="closeContactForm"
							@closeFormAfterContactAdded="refreshData"
						/>
					</div>
				</div>
			</tab-content>

			<!-- CONTROL UI FOOTER BUTTON -->
			<template slot="footer" slot-scope="props">
				<div class="wizard-footer-left">
					<wizard-button
						v-if="props.activeTabIndex > 0 && !props.isLastStep"
						@click.native="props.prevTab()"
						:style="props.fillButtonStyle"
						>Précédent</wizard-button
					>
				</div>
				<div class="wizard-footer-right">
					<wizard-button
						v-if="!props.isLastStep"
						@click.native="props.nextTab()"
						class="wizard-footer-right"
						:style="props.fillButtonStyle"
						>Suivant</wizard-button
					>

					<wizard-button
						v-else-if="!clickAddContact"
						@click.native="endSocietyCreation"
						class="wizard-footer-right finish-button"
						:style="props.fillButtonStyle"
						>{{ props.isLastStep ? "Terminer" : "Suivant" }}</wizard-button
					>
				</div>
			</template>
		</form-wizard>
	</div>
</template>

<script>
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import Society from "@/entities/Society";
import Product from "@/entities/Product";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import ContactForSociety from "../contact/ContactForSociety";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Validator from "@/entities/Validator";

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";
import { VueTags } from "vue-tags-component";

// Import styles
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Create FilePond component
const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview
);

export default {
	name: "SocietyForm",
	mixins: [utilsMixin, dbFieldConvertor, validatorMixin],
	components: {
		FormWizard,
		TabContent,
		ContactForSociety,
		WizardButton,
		FilePond,
		VueCropper,
		VxTooltip,
		VueTags,
	},
	props: {
		ispopup: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			// closeFormShow: false,
			editmode: false,
			// Society Object
			society: Society.getFormFields(),
			societyId: null,
			societyContact: [],
			contactAdded: 0,
			clickAddContact: true,
			apiUrl: this.$store.state.backendApiUrl,
			commercials: null,
			alertBool: false,

			// Validator Objects
			ClientValidationObjects: {
				nameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "nameConstraint",
					required: true,
				},
				siretValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "siretConstraint",
					required: false,
				},
				commercial_idValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "commercial_idConstraint",
					required: true,
				},
				originValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "originConstraint",
					required: true,
				},
				websiteValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true,
				},
				is_ecommerceValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "is_ecommerceConstraint",
					required: true,
				},
				statusValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "statusConstraint",
					required: false,
				},
			},

			// FORM SELECT OPTIONS
			originOptions: [
				{ text: "Agence", value: 1 },
				{ text: "Salon", value: 2 },
				{ text: "Prospection", value: 3 },
				{ text: "Appel Entrant", value: 4 },
				{ text: "Réseau", value: 5 },
				{ text: "Lead entrant", value: 6 },
				{ text: "Apporteur d'affaire", value: 7 },
				{ text: "Événements", value: 8 },
			],
			statusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "Inactif", value: 0 },
			],
			ecommerceOptions: [
				{ text: "E-commerce", value: 1 },
				{ text: "Vitrine", value: 0 },
			],
			image: null,
			validators: {},
			check: true,

			//tags
			tagStyle: "z-index: 1 !important;",
			listDomaine: [],
			languages: [],
			currencies: [],
		};
	},
	created() {
		this.getAllTvaIds();
		this.getCommercials();
		this.getDomain();
		this.society.activity_domain = [];
		store.dispatch("getAllCountries");
		store.dispatch("getAllTerms");
		this.society.country = "FR";
		this.fetchLanguages();
		this.fetchCurrencies();
		//console.log(888, this.countries);
	},
	computed: {
		countries: function () {
			return store.state.countries.sort((a, b) => {
				return a.fr_fr_name.localeCompare(b.fr_fr_name);
			});
		},
		termsOptions: function () {
			return store.state.terms;
		},
		tva_ids: function () {
			return store.state.tva_ids;
		},
	},
	watch: {
		contactAdded: function () {
			//console.log("contactAdded called");
			// Fetch contact linked to the society
			this.getSocietyContact();
		},
		tva_ids: function (data) {
			//console.log("tva_ids called");
			// Fetch contact linked to the society
			if (data.length > 0) this.society.tva_id = data[0].id;
		},
	},
	methods: {
		/**
		 * Fetch the list of languages
		 */
		async fetchLanguages() {
			this.languages = await Society.getLanguages();
		},
		async fetchCurrencies() {
			this.currencies = await Product.getCurrencies();
		},
		getAllTvaIds() {
			store.dispatch("getAllTvaIds");
		},

		onTagAdded(tag) {
			if (this.society.activity_domain.indexOf(tag) < 0)
				this.society.activity_domain.push(tag);
		},

		onTagRemoved(tag) {
			this.society.activity_domain.splice(
				this.society.activity_domain.indexOf(tag),
				1
			);
		},

		getFonction(fonction) {
			if (fonction !== "null") return fonction;
			else return "";
		},

		copyDashboardUrlToClipboard() {
			// A IMPLEMENTER ET TESTER
			// Url.text = "dashboard-service-account@dashboard-1603872171362.iam.gserviceaccount.com";
			const el = document.createElement("textarea");
			el.value =
				"dashboard-service-account@dashboard-1603872171362.iam.gserviceaccount.com";
			el.setAttribute("readonly", "");
			el.style.position = "absolute";
			el.style.left = "-9999px";
			document.body.appendChild(el);
			const selected =
				document.getSelection().rangeCount > 0
					? document.getSelection().getRangeAt(0)
					: false;
			el.select();
			document.execCommand("copy");
			document.body.removeChild(el);
			if (selected) {
				document.getSelection().removeAllRanges();
				document.getSelection().addRange(selected);
			}
			this.alertBool = true;
			setTimeout(() => {
				this.alertBool = false;
			}, 2000);
		},
		validateOne(val, name) {
			let value = val;
			value == 0 && name !== "siret" ? (value = "0") : "";

			let constname = name + "Constraint";

			if (name == "activity_domain") {
				constname = "statusConstraint";
				value = this.society.activity_domain.length;
			}

			if (name == "tva" && val && this.validators["country"].errText)
				this.validators["country"].errText = "";

			if (name == "country" || name == "tva") {
				constname = "nameConstraint";
				if (this.society.country == "FR") this.society.tva_id = 1;
			}

			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			if (
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
			) {
				if (
					name == "name" ||
					name == "origin" ||
					name == "commercial_id" ||
					name == "is_ecommerce"
				) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
				}
				if (name == "activity_domain" && value == 0)
					this.validators[name].errText = "Ce champ ne peut être vide.";
				if (name == "activity_domain" && value > 0)
					this.validators[name].errText = "";
			}
			if (
				name == "country" &&
				this.countries.filter(
					(country) => country.tva_required == 1 && country.alpha2 == value
				).length > 0 &&
				!this.society.tva
			)
				this.validators[name].errText = "Ce champ ne peut être vide.";
			if (
				name == "country" &&
				this.countries.filter(
					(country) => country.tva_required == 1 && country.alpha2 == value
				).length == 0
			)
				this.validators[name].errText = "";
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return " border: 1px solid #ff0000 !important; ";
			} else if (this.validators[name] && this.validators[name].errText == "") {
				return " border: 1px solid green !important;";
			} else {
				return " border: none !important;";
			}
		},
		/**
		 * Send the data to tha API to create the new society
		 * If the form is successfully sent, the society is redirect to Client.vue
		 */
		saveSociety() {
			this.check = true;
			let fields = [
				"name",
				"activity_domain",
				"origin",
				"websiteOptional",
				"commercial_id",
				"is_ecommerce",
				"codePostal",
				"isNumber",
				"siret",
				"phone",
				"country",
				"tva",
			];

			for (let i = 0; i < fields.length; i++) {
				let name = fields[i] + "Constraint";
				let value = this.society[fields[i]];

				value == 0 && fields[i] !== "siret" ? (value = "0") : "";

				if (fields[i] == "country" || fields[i] == "tva") {
					name = "nameConstraint";
					if (this.society.country == "FR") this.society.tva_id = 1;
				}
				if (fields[i] == "tva" && value && this.validators["country"].errText)
					this.validators["country"].errText = "";

				if (fields[i] == "codePostal") value = this.society.postal_code;

				if (fields[i] == "activity_domain") {
					name = "statusConstraint";
					value = this.society.activity_domain.length;
				}

				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);

				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					if (
						fields[i] == "name" ||
						fields[i] == "origin" ||
						fields[i] == "commercial_id" ||
						fields[i] == "is_ecommerce"
					) {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					}
					if (fields[i] == "activity_domain" && value == 0)
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					if (fields[i] == "activity_domain" && value > 0)
						this.validators[fields[i]].errText = "";
				}

				if (
					fields[i] == "country" &&
					this.countries.filter(
						(country) => country.tva_required == 1 && country.alpha2 == value
					).length > 0 &&
					!this.society.tva
				) {
					this.validators[fields[i]].valid = false;
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
				}
				if (
					fields[i] == "country" &&
					this.countries.filter(
						(country) => country.tva_required == 1 && country.alpha2 == value
					).length == 0
				) {
					this.validators[fields[i]].valid = true;
					this.validators[fields[i]].errText = "";
				}

				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
				this.$forceUpdate();
			}
			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				if (!this.editmode) {
					this.$http
						.post(this.apiUrl + "society/new", {
							status: true,
							name: this.society.name,
							adress: this.society.adress,
							adress_complement: this.society.adress_complement,
							country: this.countries.filter(
								(country) => country.alpha2 == this.society.country
							)[0].fr_fr_name,
							phone: this.society.phone,
							city: this.society.city,
							postal_code: this.society.postal_code,
							tva: this.society.tva,
							siret: this.society.siret,
							website: this.society.website,
							origin: this.society.origin,
							is_ecommerce: this.society.is_ecommerce,
							gsc_url: this.society.gsc_url,
							analytics_id: this.society.analytics_id,
							google_ads_mcc: this.society.google_ads_mcc,
							commercial_id: this.society.commercial_id,
							activity_domain: this.society.activity_domain,
							tva_id: this.society.tva_id,
							country_id: this.countries.filter(
								(country) => country.alpha2 == this.society.country
							)[0].id,
							term_id: this.society.term_id,
							language_id: this.society.language_id,
							currency_id: this.society.currency_id,
						})
						.then((res) => {
							this.societyId = res.data.insertId;
							this.society.id = res.data.insertId;
							this.editmode = true;
							// Send a success notification to the user
							this.$vs.notify({
								title: "Succès",
								text: "Client ajouté avec succès.",
							});
							if (res.data.pennylaneError) {
								this.$vs.notify({
									title: "Attention",
									text: "Le client a été ajouté mais une erreur est survenue lors de la création du client dans Pennylane. Contactez le support apres la création.",
									color: "warning",
								});
							}

							//Si l'image est présente upload l'image
							if (this.image) {
								// this.addImageToPost()
								this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
									//console.log("cropping", blob);
									let formData = new FormData();
									formData.append("image", blob, "society.png");

									this.society.image = formData;
									//console.log("Formdata: ", formData);
									this.$http
										.post(
											this.apiUrl + "society/updateImage/" + this.society.id,
											formData,
											{
												headers: {
													accept: "application/json",
													"Accept-Language": "en-US,en;q=0.8",
													"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
												},
											}
										)
										.then(() => {
											this.$vs.notify({
												title: "Succès",
												text: "Image du client ajoutée avec succès.",
											});
										})
										.catch((err) => {
											this.$vs.notify({
												title: "Echec",
												text: "L'image du client n'a pas été ajoutée.",
											});
										});
								});
							}
						})
						.catch((err) => {
							//console.log(err);
						});
					return true;
				} else {
					this.$http
						.post(this.apiUrl + "society/update", {
							society: {
								id: this.societyId,
								status: true,
								name: this.society.name,
								adress: this.society.adress,
								adress_complement: this.society.adress_complement,
								country: this.countries.filter(
									(country) => country.alpha2 == this.society.country
								)[0].fr_fr_name,
								phone: this.society.phone,
								city: this.society.city,
								postal_code: this.society.postal_code,
								tva: this.society.tva,
								siret: this.society.siret,
								website: this.society.website,
								origin: this.society.origin,
								is_ecommerce: this.society.is_ecommerce,
								gsc_url: this.society.gsc_url,
								analytics_id: this.society.analytics_id,
								google_ads_mcc: this.society.google_ads_mcc,
								commercial_id: this.society.commercial_id,
								activity_domain: this.society.activity_domain,
								tva_id: this.society.tva_id,
								language_id: this.society.language_id,
								currency_id: this.society.currency_id,
								country_id: this.countries.filter(
									(country) => country.alpha2 == this.society.country
								)[0].id,
								term_id: this.society.term_id,
								last_update_timestamp:
									new Date().toISOString().substr(0, 10) + " 02:00:00",
								creation_timestamp:
									new Date().toISOString().substr(0, 10) + " 02:00:00",
							},
							id: this.societyId,
						})
						.then((res) => {
							// Send a success notification to the user
							this.$vs.notify({
								title: "Succès",
								text: "Client modifié avec succès.",
							});

							//Si l'image est présente upload l'image
							if (this.image) {
								// this.addImageToPost()
								this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
									//console.log("cropping", blob);
									let formData = new FormData();
									formData.append("image", blob, "society.png");

									this.society.image = formData;
									//console.log("Formdata: ", formData);
									this.$http
										.post(
											this.apiUrl + "society/updateImage/" + this.society.id,
											formData,
											{
												headers: {
													accept: "application/json",
													"Accept-Language": "en-US,en;q=0.8",
													"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
												},
											}
										)
										.then(() => {
											this.$vs.notify({
												title: "Succès",
												text: "Image du client ajoutée avec succès.",
											});
										})
										.catch((err) => {
											this.$vs.notify({
												title: "Echec",
												text: "L'image du client n'a pas été ajoutée.",
											});
										});
								});
							}
						})
						.catch((err) => {
							//console.log(err);
						});
					return true;
				}
			}
		},

		/**
		 * Insert Rankwell collaborators' list to this.commercials
		 */
		getCommercials() {
			this.$http
				.get(this.apiUrl + "users/all/rankwell")
				.then((fetchedRankwell) => {
					this.commercials = this.sortABC(
						fetchedRankwell.data
							.filter((collaborator) => [4, 6, 9].includes(collaborator.type))
							.filter((collaborator) => collaborator.status == 1),
						"firstname"
					);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Get the ID for the newly created society to associate it with contacts
		 */
		getSocietyId() {
			this.$http
				.get(this.apiUrl + "society/getId/" + this.society.name)
				.then((res) => {
					this.society.id = res.data.id;
				})
				.catch((err) => console.log(err));
		},

		getDomain() {
			this.$http
				.get(this.apiUrl + "tags/all")
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.listDomaine = tmp;
				})
				.catch((err) => console.log(err));
		},

		/**
		 * Fetch all contact corresponding to a society from our API
		 */
		getSocietyContact() {
			// this.getSocietyId();
			this.$http
				.get(this.apiUrl + "society/getId/" + this.society.name)
				.then((res) => {
					this.society.id = res.data.id;
				})
				.then(() => {
					this.$http
						.get(this.apiUrl + "users/getuserforsociety/" + this.society.id)
						.then((res) => {
							this.societyContact = res.data;
							//console.log("getSocietyContact");
						});
				})
				.catch((err) => console.log(err));
		},

		showContactForm() {
			this.clickAddContact = true;
		},

		closeContactForm(value) {
			this.clickAddContact = value;
		},

		refreshData(value) {
			// this.closeFormShow = true;
			this.contactAdded += value;
			this.clickAddContact = false; // Close the form
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			if (this.$props.ispopup) {
				if (this.society.id) {
					this.$emit("close-popup", this.society.id);
				} else {
					this.$emit("close-popup", null);
				}
			} else {
				this.$router.go(-1);
			}
		},

		endSocietyCreation() {
			let mailList = {
				new_society: true,
				mail_list: this.societyContact,
				society_id: this.society.id,
			};
			this.$http
				.post(this.apiUrl + "usersSocieties/update/qb/mail", mailList)
				.then((result, err) => {
					if (err) {
						this.$vs.notify({
							title: "Erreur",
							text: err,
						});
					}
					this.returnPrevRoute();
				})
				.catch((err) => {
					this.$vs.notify({
						title: "Erreur",
						text: err,
					});
					this.returnPrevRoute();
				});
		},

		addImagePreview(e) {
			this.image = URL.createObjectURL(e.target.files[0]);
		},

		addImageToPost() {
			this.$refs.cropper
				.getCroppedCanvas({ width: 264, height: 150 })
				.toBlob((blob) => {
					//console.log("cropping", blob);
					let formData = new FormData();
					formData.append("image", blob, "society.png");
					this.society.image = formData;
				});
		},
		imageZoom() {
			this.$refs.cropper.relativeZoom(0.1);
		},

		imageDezoom() {
			this.$refs.cropper.relativeZoom(-0.1);
		},
	},
};
</script>

<style>
.center_div {
	justify-content: center;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.table_sizing {
	max-width: 600px;
}

.bottom {
	align-self: flex-end;
}
.center {
	align-self: center;
}
.input-group-border {
	border: solid rgb(195, 195, 195) 1px;
	border-radius: 10px;
	padding: 0;
}
.domain {
	position: absolute;
	z-index: 1;
	background: white;
	margin-left: 50px;
	border: 1px solid grey;
	padding: 5px;
}
.domain-line:hover {
	cursor: pointer;
}
.noBorder {
	border: none;
}
.inlineB {
	width: calc(100% - 30px) !important;
}
.vx-input-group-default.flex-grow {
	width: inherit;
}
input::placeholder {
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	font-weight: 400;
	color: black;
	padding: 0.2rem !important;
	font-size: 0.85rem;
}
.tag {
	height: auto !important;
	background-color: rgb(180, 180, 180) !important;
}
.tags__active {
	border-radius: 0 5px 5px 0 !important;
}
.tags__list {
	display: grid !important;
	max-height: 300px !important;
	overflow: auto !important;
}
.tags__list-item {
	min-height: auto !important;
	margin-bottom: 1px;
	padding: 0 5px 0 5px !important;
}
.tags__list-item-tag {
	height: auto !important;
	align-self: center;
	background-color: rgb(180, 180, 180) !important;
}
.tags__search {
	border: none;
}
</style>
